import script from "./AdminHtmlImages.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminHtmlImages.vue?vue&type=script&setup=true&lang=js"

import "./AdminHtmlImages.vue?vue&type=style&index=0&id=09cbfa30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09cbfa30"]])

export default __exports__